import {connect} from "react-redux";
import {withTranslation} from "react-i18next";
import PayPalButton from "../../../components/checkout/dataSummaryBox/PayPalButton";
import type {ApplicationState} from "../../../reducers";
import {
    notifyPayPalPaymentCancelled,
    notifyPayPalPaymentSuccessful,
    setPaymentError
} from "../../../actions/order";

const mapStateToProps = (state: ApplicationState, _ownProps) => {
    return {
        payPalPaymentRef: state.cart.paymentFacility.account.referenceId,
        paymentMethod: state.cart.paymentFacility.paymentMethod,
	};
};

const mapDispatchToProps = dispatch => {
	return {
        onCreateOrder: () => {
        },
        onPaymentSuccess: (_referenceId: string) => {
            dispatch(notifyPayPalPaymentSuccessful());
        },
        onPaymentCancelled: (_referenceId: string) => {
            dispatch(notifyPayPalPaymentCancelled())
        },
		onPaymentError: (paymentMethod: string) => {
			dispatch(setPaymentError(paymentMethod));
		}
	};
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(PayPalButton));
